import BaseService from './BaseService'
import { CustomAxiosHeaders } from '../config/services'
import { FetchRecentlyViewed } from '../types/recently-viewed'
import { TrackEventBody } from '../types/onboarding'
import { requests } from '.'
import servicesConfig from '../config/services'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'OnboardingService'
const host = servicesConfig.Onboarding
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

interface ICompanyIdBody {
  companyId: string
}

interface IStripeMetaData {
  reseller?: string
  tosAcceptedBy?: string
  ppAcceptedBy?: string
  tosAcceptedDate?: string
  ppAcceptedDate?: string
  tosVersion?: string
  ppVersion?: string
  niche?: string
  clientCount?: string
  previousProduct?: string
  onboardingKickoffEvent?: string
}


interface IUpdateStripeCustomer extends ICompanyIdBody {
  metaData: IStripeMetaData
}

interface IUpdateContactInfo extends ICompanyIdBody {
  clientCount: string
  niche: string
  isReselling: string
  previousProduct?: string
  website?: string
}


class OnboardingService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl, true)
  }
  createTosLogs = (body: any) => this.requests.post('/tos',body)
  recentlyViewed = (params: FetchRecentlyViewed) => this.requests.get(`/${params.locationId}/recently-visited?skip=${params.skip}&limit=${params.limit}`)
  verifyStatus = (companyId: string) => this.requests.get(`/verify/status?companyId=${companyId}`)
  onboardingTagTaskScheduler = (body: ICompanyIdBody) => this.requests.post('/tags/task-scheduler', body)
  getStripeSubscriptionList = (body: ICompanyIdBody,stripeCustomerId: string) => this.requests.post(`/stripe/list-subscriptions/${stripeCustomerId}`, body)
  updateStripeCustomer = (body: IUpdateStripeCustomer) => this.requests.put(`/stripe/customer`, body)
  updateContactInfo = (body: IUpdateContactInfo) => this.requests.put(`/info/contacts`, body)
  getVersion = (params: ICompanyIdBody) => this.requests.get(`/version?companyId=${params.companyId}`)
  getInfo = (params: ICompanyIdBody) => this.requests.get(`/version/${params.companyId}`)
  trackEvents = (body: TrackEventBody) => this.requests.post('/track/events', body)
}

const onboardingService = new OnboardingService(BaseService.servicesConfig.Onboarding as string)

export default onboardingService

